module.exports = __webpack_public_path__ + "static/img/section-ware.8dc09cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course-detail/section-ware.png
// module id = 3EdV
// module chunks = 1